// extracted by mini-css-extract-plugin
export default {"container":"Tm-z","bubbleNav":"Um-z","graphic":"Vm-z","contact":"Wm-z"};